import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken,getUserInfo,setUserInfo,removeUserInfo,setloginType,getloginType } from "@/utils/auth";
Vue.use(Vuex)
const getDefaultState = () => {
  return {
    token: getToken(),
    userInfo: getUserInfo() || {},
    loginType:getloginType() || 0,  //0用户登录 1企业登录
  };
};

const state = getDefaultState();
export default new Vuex.Store({
  state: getDefaultState(),
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    loginType:state => state.loginType,
  },
  mutations: {
    RESET_STATE: state => {
      Object.assign(state, getDefaultState());
    },
    SET_TOKEN: (state, token) => {
      setToken(token);
      state.token = token;
    },
    SET_USERINFO: (state, userInfo) => {
      setUserInfo(userInfo)
      state.userInfo = userInfo;
    },
    SET_LoginType: (state, type) => {
      setloginType(type)
      state.loginType = type;
    },
  },
  actions: {
    logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        removeToken();
        removeUserInfo();
        commit("RESET_STATE");
        resolve();
      });
    },
  },
  modules: {
  }
})
